import { useState } from 'react'
import { useInterval } from './useInterval'

export function useCopyToClipboard () {
  const [copied, setCopied] = useState(false)
  useInterval(copied ? 3000 : undefined, () => { setCopied(false) })
  async function handleCopyToClipboard (text): Promise<void> {
    try {
      await navigator.clipboard.writeText(text)
    } catch (error) {
      console.log(error)
    }
    setCopied(true)
  }

  return {
    copied,
    copyText: handleCopyToClipboard,
  }
}
